import React from 'react';
import classnames from 'classnames';
import s from './Sidebar.scss';

export interface Props {
  className?: string;
  children?: React.ReactNode;
}

const Sidebar: React.FC<Props> = ({ className, children }) => (
  <div className={classnames(s['root'], className)}>{children}</div>
);
Sidebar.displayName = 'Sidebar';

export default Sidebar;
